import React from "react";
import OpenTasks from "./OpenTasks";
import AllTasks from "./AllTasks";
import { getTranslation as translate } from "logic/LocaleManager";

// DevExtreme components
import TabPanel, { Item } from 'devextreme-react/tab-panel';

// Component styles
import classes from "./UserTasks.module.scss";

function UserTasks(props) {

  return (
    <TabPanel
      className={classes.tabPanel}
      focusStateEnabled={false}
      noDataText=""
      height="100%"
    >
      <Item
        title={translate("sideBar.openTasks", "Open Tasks")}
        render={() => <OpenTasks {...props} />}
      />
      <Item
        title={translate("sideBar.allTasks", "All Tasks")}
        render={() => <AllTasks {...props} />}
      />
    </TabPanel>
  );
}
export default (UserTasks);